import { render } from "./OrgDetailsPage.vue?vue&type=template&id=65841b65&scoped=true"
import script from "./OrgDetailsPage.vue?vue&type=script&lang=js"
export * from "./OrgDetailsPage.vue?vue&type=script&lang=js"

import "./OrgDetailsPage.vue?vue&type=style&index=0&id=65841b65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65841b65"]])

export default __exports__